var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimeinline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 2.667C23.36 2.675 29.325 8.64 29.333 16c0 7.364-5.97 13.333-13.333 13.333-7.364 0-13.333-5.97-13.333-13.333C2.667 8.636 8.637 2.667 16 2.667zm0 2.666C10.109 5.333 5.333 10.11 5.333 16S10.11 26.667 16 26.667C21.888 26.66 26.66 21.888 26.667 16c0-5.891-4.776-10.667-10.667-10.667zm-.184 4c.635 0 1.15.496 1.15 1.108v5.603l5.328 4.705c.468.413.5 1.112.071 1.563a1.193 1.193 0 0 1-1.624.068l-5.702-5.033a1.089 1.089 0 0 1-.372-.817v-6.09c0-.61.514-1.107 1.15-1.107z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimeinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/time.inline.a5ddd60844442a586ba01954c0ca0efa.svg";